import { IFollowUpSurveyForList } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IFollowUpSurveyForList,
    onConfirm: () => void,
    onCancel: () => void
}

const MarkAppointmentBooked = (props: IProps) => {
    let fullName = props.data != null ? props.data.firstName + ' ' + props.data.lastName:'';

    return (
        <Modal backdrop='static' bsSize='sm' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Appointment Booked</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Please confirm that you wish to mark the appointment booked for donor <strong>{fullName}</strong>.
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm Booked</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MarkAppointmentBooked;